import { normalizeImeiHubStats, type ImeiHubStatsSnapshot } from '@redevicer/shared'

const CACHE_KEY = 'redevicer_imei_hub_stats_v2'

export type { ImeiHubStatsSnapshot }

export function readImeiHubStatsCache(): ImeiHubStatsSnapshot | null {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY)
    if (!raw) return null
    return normalizeImeiHubStats(JSON.parse(raw) as Partial<ImeiHubStatsSnapshot>)
  } catch {
    return null
  }
}

export function writeImeiHubStatsCache(data: ImeiHubStatsSnapshot): void {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(data))
  } catch {
    /* quota / private mode */
  }
}
